import { Spinner } from "react-bootstrap";

export default function FullPageLoader({ size = 'lg' }) {
    return (
        <div className="w-100 h-100dvh d-flex justify-content-center align-items-center">
            <Spinner size={size} />
        </div>
    )
}